import axios from 'axios';
import { isArray } from 'lodash';
import { ApiV1Response } from '../structures/responses/axios';
import { AdvertType, GTMEvent, GTMEventType } from '../structures/responses/gtm';

const pushEvent = (gtmEvent: GTMEvent): void => {
  const eventToPush = { ...gtmEvent };
  if (eventToPush.event === 'userLoggedIn') {
    eventToPush.eventCallback = () => {
      const userLoggedInEvent = new Event('userLoggedIn');
      document.dispatchEvent(userLoggedInEvent);
    };
  }
  window.dataLayer.push(eventToPush);
};

// Create a basic GTMEvent object for the given type, including User data
const createBaseGTMEvent = (eventName: GTMEventType): GTMEvent => {
  const event: GTMEvent = {
    event: eventName,
  };

  if (window.user.id) {
    event.id = window.user.id;
  }

  if (window.user.email) {
    event.email = window.user.email;
  }

  return event;
};

// Can this user trigger a buyer level event
const canTriggerBuyerEvent = (): boolean => {
  return !window.user.role || window.user.role === 'user';
};

// For each axios response, check for the existence of GTM events from the server in the _gtmEvents
// field. If events exist, push them to the dataLayer
axios.interceptors.response.use((value: ApiV1Response) => {
  if (!value.data.gtmEvents) {
    return value;
  }

  value.data.gtmEvents.forEach(pushEvent);

  return value;
});

// When the `gtmEvent` event is triggered by a livewire component, we also want to push the event
// to the dataLayer
document.addEventListener('livewire:init', () => {
  window?.Livewire?.on('gtmEvent', (events) => {
    if (isArray(events)) {
      events.forEach(pushEvent);
    } else {
      pushEvent(events);
    }
  });
});

/**
 * Custom GTM Event triggers below
 */
document.addEventListener('DOMContentLoaded', () => {
  // buyerInterested event
  document.querySelectorAll('.buyer-interested-button').forEach((element) => {
    element.addEventListener('click', () => {
      if (!canTriggerBuyerEvent()) {
        return;
      }

      const event = createBaseGTMEvent('buyerInterested');

      // Add the listing specific data
      if (element instanceof HTMLElement) {
        event.advert_id = Number(element.dataset.advertId);
        event.advert_type = element.dataset.advertType as AdvertType | undefined;
        event.advert_breed = element.dataset.advertBreed;
      }

      pushEvent(event);
    });
  });
});
